import { Box, Link, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Link as RouterLink } from 'react-router-dom'
import { COLORS } from '../../constants'
import { Service } from '../../utils/siteContent'

function ServiceCard({ service }: { service: Service }) {
    const href = service.id === 'mentorship' ? '/mentorship' : `/services#${service.id}`
    return (
        <Box
            component="article"
            sx={{
                p: 3.5, borderRadius: 3, border: `1px solid ${COLORS.border}`, backgroundColor: COLORS.white,
                display: 'flex', flexDirection: 'column', gap: 2,
                transition: 'border-color 120ms, box-shadow 120ms',
                '&:hover': { borderColor: COLORS.accent, boxShadow: '0 10px 30px rgba(11,13,16,0.06)' },
            }}
        >
            <Box sx={{ width: 48, height: 48, borderRadius: 2, display: 'grid', placeItems: 'center', backgroundColor: COLORS.black, color: COLORS.accent }}>
                {service.icon}
            </Box>
            <Typography variant="h3">{service.title}</Typography>
            <Typography sx={{ color: 'text.secondary', flexGrow: 1 }}>{service.summary}</Typography>
            {service.pricing && (
                <Typography sx={{ fontWeight: 700 }}>Starting at {service.pricing.startingAt}</Typography>
            )}
            <Link component={RouterLink} to={href} sx={{ color: COLORS.accentOnLight, fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>
                Learn more <ArrowForwardIcon fontSize="small" />
            </Link>
        </Box>
    )
}

export default ServiceCard
